var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SelectDriver',{attrs:{"model":_vm.model}}),_c('SelectTruck',{attrs:{"model":_vm.model}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }